

/* tslint:disable */



export enum OrderBy {
    Descending = 0,
    Ascending = 1,

}


